<template>
  <div class='ml-3 mb-1'>
    <v-btn v-if='dayButton && !isTemplate' icon :disabled='loading' @click='goToToday'><v-icon>mdi-calendar-today</v-icon></v-btn>
    <v-btn v-if='weekButton && !isTemplate' icon :disabled='loading' @click='goToWeek'><v-icon>mdi-calendar-week</v-icon></v-btn>
    <v-btn v-if='monthButton && !isTemplate' icon :disabled='loading' @click='goToMonth'><v-icon>mdi-calendar-month</v-icon></v-btn>
    <v-btn v-if='!isTemplate' icon color='info' :disabled='loading' @click="$emit('prev')"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn v-if='!isTemplate' text :disabled='disableToday || loading' @click="$emit('today')">{{ title }}</v-btn>
    <v-btn v-if='!isTemplate' icon color='info' :disabled='loading' @click="$emit('next')"><v-icon>mdi-chevron-right</v-icon></v-btn>
    <selected-wos @deselectAll="deselectAll"></selected-wos>
    <v-tooltip top open-delay='700'>
      <template v-slot:activator='{ on }'>
        <v-btn
          icon
          v-on='on'
          color='grey darken-1'
          :disabled='loading'
          @click="$emit('toggleShowWOs')"
        >
          <v-icon size='20'>{{ showWOs ? 'mdi-arrow-collapse-up' : 'mdi-arrow-expand-down'}}</v-icon>
        </v-btn>
      </template>
      <span>
        {{ (showWOs ? 'Collapse' : 'Expand') + ' all routes' }}
      </span>
    </v-tooltip>
    <v-tooltip top open-delay='700'>
      <template v-slot:activator='{ on }'>
        <div v-on='on' class='d-inline-block'>
          <v-btn icon disabled>
          <!-- <v-btn v-on='on' icon :disabled='!$store.state.schedule.selectedWOs.length' @click="showDialog"> -->
            <v-icon>mdi-archive</v-icon>
          </v-btn>
        </div>
      </template>
      <!-- <span>Archive unscheduled Work Orders</span> -->
      <span>Archive currently unavailable</span>
    </v-tooltip>
    <attempted-wos name="Attempted" :amount="attempted_data.attempted"/>
    <attempted-wos name="Not Attempted" :amount="attempted_data.not_attempted"/>

    <wc-confirm
      :showDialog='showConfirm'
      @cancel="showConfirm = false"
      @confirm="archiveWOs"
      saveColor='primary'
    >
    {{ '(' + $store.state.schedule.selectedWOs.length + ') Selected WOs will be archived' }}
    </wc-confirm>
    
    <wc-confirm
      :showDialog='showError'
      @confirm="showError = false"
      hideCancel
      saveText='Okay'
      color='error'
      title='Error'
    >
    {{'You cannot ' + (isTemplate ? 'delete' : 'archive') + ' work orders that are part of a route.  Please unschedule them first.' }}
    </wc-confirm>
  </div>
</template>

<script>
import moment from 'moment'
import SelectedWOs from './SelectedWOs'
import _ from 'lodash'
import scheduleAPI from "@/api/schedule";
import AttemptedWOs from './AttemptedWOs.vue';

export default {
  name: 'schedule-shifter',
  props: {
    loading: {
      required: false,
      type: Boolean,
      default: false
    },
    title: {
      required: false,
      type: String,
      default: 'Today'
    },
    date: {
      required: false,
      default: moment().format('YYYY-MM-DD').toString()
    },
    disableToday: {
      required: false,
      type: Boolean,
      default: false
    },
    dayButton: {
      required: false,
      type: Boolean,
      default: false
    },
    weekButton: {
      required: false,
      type: Boolean,
      default: false
    },
    monthButton: {
      required: false,
      type: Boolean,
      default: false
    },
    isTemplate: {
      required: false,
      type: Boolean,
      default: false
    },
    showWOs: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  mounted(){
    this.getData();
  },
  data: () => ({
    showConfirm: false,
    showError: false,
    attempted_data: {
        "attempted": 0,
        "not_attempted": 0
    }
  }),
  computed: {
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    selectedRouteWOs () {
      return _.some(this.$store.state.schedule.selectedWOs, 'route')
      // likely need to pass in the id for the unscheduled route as a prop so comparison can be made here?
    }
  },
  methods: {
    async getData(){
        const dashboard = await scheduleAPI.getScheduleDashboard();
        this.attempted_data = {
            "attempted": dashboard.attempted,
            "not_attempted": dashboard.not_attempted
        }
    },
    goToToday () {
      this.$emit('clearScheduleData')
      this.$router.push({ name: 'ScheduleDay', params: { id: this.$route.params.id, date: this.today } })
    },
    goToWeek () {
      this.$emit('clearScheduleData')
      this.$router.push({ name: 'ScheduleWeek', params: { id: this.$route.params.id, date: this.date } })
    },
    goToMonth () {
      this.$emit('clearScheduleData')
      this.$router.push({ name: 'ScheduleMonth', params: { id: this.$route.params.id, date: this.date } })
    },
    showDialog () {
      if ( this.selectedRouteWOs ) {
        this.showError = true
      } else {
        this.showConfirm = true
      }
    },
    archiveWOs () {
      this.$emit('archiveWOs')
      this.showConfirm = false
    },
    deselectAll () {
      console.log(this.$store.state.schedule.selectedWOs)
      let payload = _.cloneDeep(this.$store.state.schedule.selectedWOs)
      this.$emit('deselect', payload)
    }
  },
  components: {
    'selected-wos': SelectedWOs,
    'attempted-wos': AttemptedWOs
  }
}
</script>